module.exports = __webpack_public_path__ + "static/media/ClemsonText.febde679.png";